import {Validators} from '@angular/forms';

import {ComponentTypesEnum} from '../../../app/shared/enums';
import {BaseControl, SelectControl} from '../../../app/shared/classes';
import {PhoneAutocompleteValueInterface} from '../../../app/shared/widgets';

export const UserEmailSelector = 'email';
export const UserPortalSelector = 'portal';

export const UserDetailsControls = (): BaseControl<string | number | PhoneAutocompleteValueInterface>[] => {
    return [
        new BaseControl({
            name: UserEmailSelector,
            value: '',
            placeholder: 'Email',
            validators: [Validators.required, Validators.email],
            componentType: ComponentTypesEnum.Text
        }),
        new SelectControl({
            name: UserPortalSelector,
            value: null,
            placeholder: 'Portal',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: []
        })
    ];
};
